'use client';
import PaginatorItemDots from './Paginator.ItemDots';
import { usePaginator } from './PaginatorContext';
import { ChevronRight } from '@icons';
import useDictionary from '@modules/Dictionary/useDictionary';

export default function PaginatorItemForward({ children = null, className = '' }) {
  const { setIndex, index, items, setScrollDirection } = usePaginator();
  const { dictionary } = useDictionary();

  const handleClick = () => {
    setScrollDirection('forward');
    if (index >= items.length - 1) return;
    setIndex(index + 1);
  };
  return (
    <PaginatorItemDots
      handleClick={handleClick}
      excludeFromIndexes={true}
      label={dictionary?.archive?.next || 'Neste'}
      disabled={index >= items.length - 1}
      className={`Paginator__item__forward ${index >= items.length - 1 ? 'Paginator__item__forward-inactive' : ''} ${className}`}
    >
      {children ? children : <ChevronRight />}
    </PaginatorItemDots>
  );
}
